exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:Roboto,sans-serif;font-size:13px;color:#5e5454;line-height:20px;letter-spacing:1px;overflow-x:hidden!important}.flexSpaceBetween{display:flex;flex-direction:row;justify-content:space-between}.heading{font-size:34px;line-height:42px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1113b816","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 63
// module chunks = 0